// Export utility functions for dashboard data

export const exportToCSV = (data, filename = 'export.csv') => {
    if (!data || data.length === 0) {
        console.warn('No data to export');
        return;
    }

    // Get headers from the first object
    const headers = Object.keys(data[0]);
    
    // Create CSV content
    const csvContent = [
        // Headers row
        headers.join(','),
        // Data rows
        ...data.map(row => 
            headers.map(header => {
                const value = row[header];
                // Handle values that contain commas or quotes
                if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
                    return `"${value.replace(/"/g, '""')}"`;
                }
                return value || '';
            }).join(',')
        )
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const exportToExcel = (data, filename = 'export.xlsx') => {
    // For Excel export, we'll use a simple CSV format that Excel can open
    // In a real application, you might want to use a library like xlsx
    exportToCSV(data, filename.replace('.xlsx', '.csv'));
};

export const exportToPDF = (data, filename = 'export.pdf') => {
    // Simple PDF export using browser's print functionality
    const printWindow = window.open('', '_blank');
    const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>${filename}</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; font-weight: bold; }
                h1 { color: #333; }
                .header { margin-bottom: 20px; }
                .date { color: #666; font-size: 12px; }
            </style>
        </head>
        <body>
            <div class="header">
                <h1>Appointment Report</h1>
                <div class="date">Generated on: ${new Date().toLocaleDateString()}</div>
            </div>
            <table>
                <thead>
                    <tr>
                        ${Object.keys(data[0] || {}).map(key => `<th>${key}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${data.map(row => 
                        `<tr>${Object.values(row).map(value => `<td>${value || ''}</td>`).join('')}</tr>`
                    ).join('')}
                </tbody>
            </table>
        </body>
        </html>
    `;
    
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.print();
};

export const formatAppointmentData = (appointments) => {
    return appointments.map(appointment => ({
        'Patient Name': appointment.Name,
        'Email': appointment.Email,
        'Phone': appointment.Phone,
        'Appointment Date': appointment.AppointmentDate,
        'Appointment Time': appointment.AppointmentTime ? 
            JSON.parse(appointment.AppointmentTime).day + ' ' + 
            JSON.parse(appointment.AppointmentTime).type + ' ' + 
            JSON.parse(appointment.AppointmentTime).hour : 'N/A',
        'Doctor': appointment.Doctor ? JSON.parse(appointment.Doctor).name : 'N/A',
        'Insurance Provider': appointment.InsuranceProvider || 'N/A',
        'Status': appointment.Status,
        'Created Date': appointment.Date
    }));
};

export const generateDashboardStats = (activeAppointments, pastAppointments) => {
    const totalAppointments = activeAppointments + pastAppointments;
    const completionRate = totalAppointments > 0 ? ((pastAppointments / totalAppointments) * 100).toFixed(1) : 0;
    
    return {
        totalAppointments,
        activeAppointments,
        pastAppointments,
        completionRate: `${completionRate}%`
    };
};
